function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "EmptyWarningIcon_svg__18_b",
  width: "102.5%",
  height: "102.4%",
  x: "-1.2%",
  y: "-.9%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feMorphology", {
  "in": "SourceAlpha",
  operator: "dilate",
  radius: 1,
  result: "shadowSpreadOuter1"
}), React.createElement("feOffset", {
  dy: 1,
  "in": "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 1
}), React.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0534309441 0"
})), React.createElement("path", {
  id: "EmptyWarningIcon_svg__17_a",
  d: "M6 0h348a6 6 0 016 6v358a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FAFBFC",
  d: "M-614-1793h850V303h-850z"
}), React.createElement("g", {
  transform: "translate(-164 -107)"
}, React.createElement("mask", {
  id: "EmptyWarningIcon_svg__19_c",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#EmptyWarningIcon_svg__17_a"
})), React.createElement("use", {
  fill: "#000",
  filter: "url(#EmptyWarningIcon_svg__18_b)",
  xlinkHref: "#EmptyWarningIcon_svg__17_a"
}), React.createElement("path", {
  fill: "#FFF",
  stroke: "#E1E9F0",
  d: "M6-.5h348a6.5 6.5 0 016.5 6.5v358a6.5 6.5 0 01-6.5 6.5H6A6.5 6.5 0 01-.5 364V6A6.5 6.5 0 016-.5z"
}), React.createElement("g", {
  mask: "url(#EmptyWarningIcon_svg__19_c)"
}, React.createElement("path", {
  fill: "#E1E9F0",
  fillRule: "nonzero",
  d: "M183.415 110.245l12.001 19.672a4 4 0 01-3.415 6.083H168a4 4 0 01-3.415-6.083l12.001-19.672a4 4 0 016.83 0zm-.946 21.244c0-1.384-1.105-2.506-2.469-2.506-1.363 0-2.469 1.122-2.469 2.506 0 1.384 1.106 2.506 2.47 2.506 1.363 0 2.468-1.122 2.468-2.506zm-4.1-17.542c-.457-.004-.832.279-.838.632v.034l.75 10.763c.03.34.397.604.838.6h1.762c.441.003.809-.26.838-.6l.75-10.763c.019-.352-.336-.65-.793-.665h-.045l-3.262-.001z"
}))));

var SvgEmptyWarningIcon = function SvgEmptyWarningIcon(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30"
  }, props), _ref, _ref2);
};

export default SvgEmptyWarningIcon;